<template>
    <div class="tag" :style="{backgroundColor: color}">
        {{name}}

        <i v-if="show_remove"
           @click.stop.prevent="$emit('remove')"
           class="fas fa-times pointer remove"></i>
    </div>
</template>

<script>
export default {
    name: 'Tag',
    props: ['name', 'color', 'show_remove'],
};
</script>

<style scoped>
    .tag { color: #FFFFFF; }
    .remove { margin-left: 1rem; }
</style>
